export default class AppInfo {
  /**
   * スマートフォンで表示中かどうか
   */
  static get isSmartPhone() {
    return (
      navigator.userAgent.indexOf('iPhone') > 0 ||
      (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)
    )
  }

  /**
   * iPadかどうかを判定する
   */
  static get isiPad() {
    const ua = window.navigator.userAgent.toLowerCase()
    return ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
  }

  /**
   * モバイル端末（iPad含む）かどうか
   */
  static get isMobile() {
    return AppInfo.isiPad || AppInfo.isSmartPhone
  }
}
